import _ from 'lodash'

function makeFieldsObject(fields, fieldPath) {
  return _.reduce(
    fields,
    (obj, field) => {
      obj[field] = `${fieldPath}.${field}`
      return obj
    },
    {}
  )
}
export const guestFieldNames = [
  'room',
  'firstName',
  'lastName',
  'email',
  'phone',
  'guestType',
  'isPrimary',
  'gender',
  'isMeditator',
  'isAnonymous'
]
export const guestFields = makeFieldsObject(
  guestFieldNames,
  'listings[].rooms[].guests[]'
)
export const guestDetailsFields = makeFieldsObject(
  guestFieldNames,
  'guestDetails[]'
)

export const roomFields = makeFieldsObject(
  [
    'roomId',
    'roomConfiguration',
    'numGuests',
    'numChildren',
    'useCustomPrice',
    'customPrice',
    'order'
  ],
  'listings[].rooms[]'
)

export const listingFields = makeFieldsObject(['numRooms'], 'listings[]')

export const addressFields = makeFieldsObject(
  ['street', 'city', 'state', 'zip', 'country'],
  'commonGuestFields.address'
)
export const commonGuestFieldsList = [
  'howDidYouHear',
  'howDidYouHearOther',
  'visitComment',
  'visitPurpose',
  'whatMotivated',
  'whatMotivatedOther',
  'peopleTakenIshaProgram',
  'firstTimeVisits',
  'volunteerHandlingBooking'
]
export const commonGuestFields = makeFieldsObject(
  commonGuestFieldsList,
  'commonGuestFields'
)

export const roomSelectionFields = [
  'payingGuest',
  ...Object.values(guestDetailsFields),
  ...Object.values(listingFields),
  ...Object.values(roomFields),
  guestFields.guestType,
  guestFields.isMeditator,
  guestFields.isAnonymous
]

export const guestEntryFields = [
  'payingGuest',
  ...Object.values(commonGuestFields),
  ...Object.values(addressFields),
  ...roomSelectionFields,
  ...Object.values(listingFields),
  ...Object.values(guestFields),
  ...Object.values(roomFields),
  'roomSelectBox'
]

export const defaultPayingGuestValue = 'listings[0].rooms[0].guests[0]'

export const defaultGuestValues = {
  guestType: 'adult',
  isMeditator: false,
  isAnonymous: false
}

export const defaultRoomValues = {
  numGuests: 1,
  numChildren: 0,
  useCustomPrice: false,
  customPrice: 0,
  guests: [defaultGuestValues],
  order: 0
}

export const genders = ['male', 'female']

export const defaultListingValues = {}



// WEBPACK FOOTER //
// ./src/redux/formSchema.js